<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Araç Tipi Güncelle' : 'Araç Tipi Oluştur'" no-close-on-esc no-close-on-backdrop>
            <type-create-or-update v-model="type"></type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-overlay :show="loading" opacity="0.2" rounded="sm" :class="!types.length ? 'p-3' : 'p-1'">
            <div class="text-right" v-if="types.length">
                <button v-on:click="collapseAll" class="btn btn-sm mb-1 btn-light">
                    <feather-icon icon="MinusSquareIcon" class="mr-50"></feather-icon>
                    Hepsini Kapat
                </button>
            </div>
            <div v-for="(item, index) in types" :key="index" :class="index != 0 ? 'mt-1' : null">
                <div class="alert alert-dark mb-0">
                    <div class="alert-body px-50 py-25">
                        <div class="row align-items-center p-25">
                            <div class="col">
                                {{ item.VehicleTypeBaseType }}
                            </div>
                            <div class="col-auto">
                                <button v-b-tooltip.noninteractive.hover.bottom title="Alt Öğe Ekle" v-on:click="createNew(item)" class="btn btn-sm rounded-circle btn-icon btn-primary mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <v-tree-view ref="treeViews" v-model="item.VehicleTypeTreeResponseModel">
                    <template #data="{ data }">
                        <div class="row align-items-center">
                            <div v-if="data.Image" class="col-auto">
                                <img v-image-error class="vehicle-type-image" :src="data.Image" />
                            </div>
                            <div class="col">
                                <div class="d-flex align-items-center">
                                    {{ data.Name }}
                                    <b-badge v-if="data.IsNeedHGS" variant="light-warning" class="ml-50"> HGS </b-badge>
                                </div>
                            </div>
                            <div class="col-auto text-right">
                                <button v-b-tooltip.noninteractive.hover.bottom title="Alt Öğe Ekle" v-on:click="createNew(data)" class="btn btn-sm rounded-circle btn-icon btn-primary mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Düzenle" v-on:click="edit(data)" class="btn btn-sm btn-icon btn-flat-secondary ml-25 mr-25">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Sil" v-on:click="del(data)" class="btn btn-sm btn-icon btn-flat-danger ml-25">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </template>
                </v-tree-view>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import VTreeView from "@/components/v-tree-view/VTreeView";
import { BCard, BOverlay, VBTooltip, BBadge } from "bootstrap-vue";
import VehicleDefinitionsApi from "@/api/vehicle-definitions";
import TypeCreateOrUpdate from "./components/TypeCreateOrUpdate";
import Additional from "@/utilities/additional";
export default {
    components: {
        VTreeView,
        TypeCreateOrUpdate,
        BOverlay,
        BCard,
        BBadge,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            types: [],
            loading: false,
            editing: false,
            type: {
                Id: 0,
                Name: null,
                Code: null,
                ParentVehicleTypeId: null,
                VehicleTypeBaseTypeId: null,
                Image: null,
                IsCanBeConnectToTruck: null,
                IsCanGroupNumberDefinable: null,
                GroupNumber: null,
                IsNeedHGS: false,
            },
        };
    },
    mounted() {
        this.getTypes();
    },
    methods: {
        createNew(item, type) {
            this.clearForm();
            this.type.VehicleTypeBaseTypeId = item.VehicleTypeBaseTypeId;
            this.type.ParentVehicleTypeId = item.Id;
            this.$showModal("create-or-update");
        },
        clearForm() {
            this.editing = false;
            this.type.Id = 0;
            this.type.Name = null;
            this.type.Code = null;
            this.type.ParentVehicleTypeId = null;
            this.type.Image = null;
            this.type.VehicleTypeBaseTypeId = null;
            this.type.IsCanBeConnectToTruck = null;
            this.type.IsCanGroupNumberDefinable = null;
            this.type.GroupNumber = null;
            this.type.IsNeedHGS = false;
        },
        async createOrUpdate() {
            this.loading = true;
            !this.type.Code ? (this.type.Code = null) : null;
            let formData = await Additional.ToFormData(this.type, ["Image"]);
            VehicleDefinitionsApi.Type.CreateOrUpdate(this.editing, formData)
                .then((res) => {
                    if (res.data.Success) {
                        this.getTypes();
                        this.clearForm();
                        this.$hideModal("create-or-update");
                    }
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        edit(item) {
            this.clearForm();
            this.editing = true;
            this.type.Id = item.Id;
            this.type.Name = item.Name;
            this.type.Code = item.Code;
            this.type.ParentVehicleTypeId = item.ParentVehicleTypeId;
            this.type.Image = item.Image;
            this.type.VehicleTypeBaseTypeId = item.VehicleTypeBaseTypeId;
            this.type.IsCanBeConnectToTruck = item.IsCanBeConnectToTruck;
            this.type.IsCanGroupNumberDefinable = item.IsCanGroupNumberDefinable;
            this.type.GroupNumber = item.GroupNumber;
            this.type.IsNeedHGS = item.IsNeedHGS;
            this.$showModal("create-or-update");
        },
        getTypes() {
            this.loading = true;
            VehicleDefinitionsApi.Type.TreeList()
                .then((res) => {
                    if (res.data.Success) {
                        this.types = res.data.Data;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        del(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.Name} araç tipini ve buna bağlı olan tüm araç tiplerini silecektir ve geri alınamaz.`).then((result) => {
                if (result) {
                    VehicleDefinitionsApi.Type.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.getTypes();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
        collapseAll() {
            this.$refs.treeViews.forEach((tv) => tv.collapseAll());
        },
    },
};
</script>

<style>
.vehicle-type-image {
    width: auto;
    height: 30px;
}
</style>
